// import { useState } from 'react';
// import { toast } from 'react-toastify';
import { supistaApiPost } from '../utils/connections';
import { toast } from 'react-toastify';
import { removeExtraDataFromSchema, reportSchemaValidation } from '../utils/helperFunction';
import { mls } from 'lib/multilanguagesupport';
import { FaTimes } from 'react-icons/fa';

interface mainProps {
  appID: string;
  settingsSchema: any;
  handleReportSettingsPopUp: Function;
  handleSave: Function;
  handleDelete: Function;
  isNew: boolean;
}
const Header = ({
  settingsSchema,
  appID,
  handleReportSettingsPopUp,
  handleSave,
  handleDelete,
  isNew,
}: mainProps) => {
  // const [isConfirmationDiv, setIsConfirmationDiv] = useState(false);

  const saveFunction = async () => {
    const isValidate = reportSchemaValidation(settingsSchema);
    if (isValidate.skip) {
      toast.warn(mls(isValidate.msg), {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      return;
    }
    const finalSchema = removeExtraDataFromSchema(settingsSchema);

    const endPoint = 'ReportSettings/create';
    try {
      const res = await supistaApiPost(endPoint, finalSchema, appID);
      if (!res.__d3__error) {
        // toast.success('Saved Successfully', {});
        handleSave(settingsSchema, settingsSchema['dashID']);
      }
    } catch (err) {
      console.log('error encountered while creating new dashboard', err);
    }
  };
  const removeFunction = async () => {
    const endPoint = 'ReportSettings/delete';
    const dataForRemove = {
      reportID: settingsSchema.reportID || '',
      appID: appID || '',
    };
    const res = await supistaApiPost(endPoint, dataForRemove, appID);
    if (!res.__d3__error) {
      handleDelete(settingsSchema.reportID);
    }
  };
  return (
    <div className='MainUpperHeader'>
      <div className='title'>{mls('Report Settings')}</div>
      <div className='subTitle'>{mls('Edit Report Settings here')}</div>
      <div className='goleftSide'></div>
      {!isNew ? (
        <div className='deleteButtonDiv'>
          <button type='button' className='btn btn-sm btn-danger' onClick={() => removeFunction()}>
            <span className='indicator-label'>{mls('Delete')}</span>
          </button>
        </div>
      ) : null}
      <div className='saveButtonDiv'>
        <button className='btn btn-sm btn-primary' onClick={() => saveFunction()}>
          <span className='indicator-label'>{mls('Save')}</span>
        </button>
      </div>
      <div className='closeButton' onClick={() => handleReportSettingsPopUp(false)}>
        <FaTimes />
      </div>
      {/* {isConfirmationDiv && (
        <ConfirmationDiv
          handleReportSettingsPopUp={handleReportSettingsPopUp}
          setIsConfirmationDiv={setIsConfirmationDiv}
        />
      )} */}
    </div>
  );
};

export default Header;

// interface ConfirmationDivProps {
//   setIsConfirmationDiv: Function;
//   handleReportSettingsPopUp: Function;
// }
// const ConfirmationDiv = ({
//   handleReportSettingsPopUp,
//   setIsConfirmationDiv,
// }: ConfirmationDivProps) => {
//   const handleAction = (action: boolean) => {
//     if (action) {
//       handleReportSettingsPopUp(!action);
//       setIsConfirmationDiv(!action);
//       return;
//     }
//     setIsConfirmationDiv(action);
//   };

//   return (
//     <>
//       <div className='confirmationContainer'>
//         <div className='confirmationDiv'>
//           <div className='msg'>Are you sure you want to close this windows?</div>
//           <div className='ButtonContainer'>
//             <button className='primaryButtonSmall' onClick={() => handleAction(true)}>
//               yes
//             </button>
//             <button className='primaryButtonSmall' onClick={() => handleAction(false)}>
//               no
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
